export const SYNC_STATUS = {
  NOT_SYNCED: 0,
  SYNCING: 1,
  SYNCED: 2,
};
